var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrimo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 950,
    height: 450,
    viewBox: "42.540985107421875 43.64242172241211 1039.6484985351562 462.714542388916",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.775 388.193c-12.806 54.991-30.088 98.348-107.474 97.08-80.123 1.268-93.85-35.849-107.473-97.08z",
    fill: "#2c2c2b",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272.774 388.193c-12.169 52.237-28.364 93.994-96.339 96.924-40.983-2.569-75.825-37.904-87.769-96.924z",
    fill: "#171717",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.536 443.918c5.33 0 9.65-3.837 9.65-8.571 0-4.733-4.32-8.57-9.65-8.57-5.329 0-9.649 3.837-9.649 8.57s4.32 8.571 9.649 8.571Z",
    fill: "#d9e3f0",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M553.852 401.965c-3.061 41.823-22.377 68.047-35.922 79.794-22.887 19.847-43.088 23.318-71.425 24.429-21.569.845-44.692-.92-65.69-18.4-22.482-18.718-30.083-45.625-30.083-80.899 0-58.522 54.405-127.534 110.515-127.534s96.879 64.244 92.605 122.61Z",
    fill: "#171717",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M540.023 408.838c0 53.464-33.922 95.601-76.624 95.601s-78.013-42.137-78.013-95.601c0-53.465 34.617-96.807 77.318-96.807s77.319 43.342 77.319 96.807Z",
    fill: "#373736",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M523.488 408.229c0 43.169-23.967 77.501-60.842 78.163-30.877.555-60.73-36.403-60.73-79.569s27.127-76.755 60.73-76.755c35.427 0 60.842 34.995 60.842 78.164z",
    fill: "#d4d4d4",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M518.344 408.393c0 16.831-3.84 32.236-10.775 44.482l-14.184-19.36-10.831 26.986 4.717 13.825c-7.213 4.318-15.489 6.769-24.623 6.941-6.208.115-12.378-1.465-18.211-4.413l10.419-24.572-24.437-3.594-8.014 8.254c-9.078-12.971-15.023-29.992-15.341-48.324l21.846 3.062-5.461-30.656-9.897-7.93c6.99-16.888 19.087-29.555 33.663-34.842l3.858 30.506 21.996-14.909 2.105-16.622c14.949 4.164 27.085 15.747 34.633 31.551l-18.77 13.332 16.795 20.748 10.327-.381c.131 1.94.187 3.917.187 5.916z",
    fill: "#333",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M464.928 417.23c4.152 0 7.518-4.027 7.518-8.996 0-4.968-3.366-8.996-7.518-8.996s-7.517 4.028-7.517 8.996 3.366 8.996 7.517 8.996Z",
    fill: "#fdfdfe",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M464.928 414.465c2.874 0 5.205-2.788 5.205-6.227s-2.331-6.226-5.205-6.226-5.205 2.787-5.205 6.226 2.33 6.227 5.205 6.227",
    fill: "#000"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1068.09 391.093c3.38 58.407-31.39 93.122-70.917 93.122-39.523 0-72.208-41.043-72.208-93.122s32.042-94.296 71.565-94.296c39.52 0 68.56 42.305 71.56 94.296Z",
    fill: "#373737",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.83 405.065c.34-5.048.36-10.343.05-15.819-2.99-51.989-32.03-94.288-71.553-94.288-39.52 0-71.573 42.209-71.573 94.288s32.876 94.958 72.397 94.958c2.002 0 4.049-.09 6.029-.293-7.874 1.217-16.502-.176-25.544.185-21.572.856-43.952-2.682-61.205-18.163-11.539-10.344-19.794-23.978-24.698-40.473l22.471-.879v-53.499s.855-79.526 73.036-96.022c0 0 73.26-16.699 84.87 100.462l.02.09 1.51 22.963z",
    fill: "#171717",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.49 390.49c0 43.036-22.4 77.262-56.859 77.922-28.852.553-56.748-36.29-56.748-79.326s25.35-76.518 56.748-76.518c33.109 0 56.859 34.887 56.859 77.922Z",
    fill: "#d4d4d4",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.68 390.652c0 16.78-3.59 32.138-10.07 44.347l-13.25-19.301-10.12 26.902 4.4 13.783c-6.74 4.304-14.47 6.749-23.009 6.92-5.801.113-11.566-1.46-17.018-4.399l9.737-24.495-22.835-3.583-7.491 8.227c-8.482-12.93-14.038-29.899-14.335-48.175l20.415 3.053-5.103-30.562-9.25-7.905c6.532-16.836 17.838-29.463 31.457-34.734l3.606 30.411 20.556-14.864 1.97-16.57c13.97 4.153 25.31 15.698 32.36 31.455l-17.54 13.291 15.69 20.685 9.65-.379c.12 1.934.18 3.906.18 5.898z",
    fill: "#333",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M999.764 399.461c3.876 0 7.026-4.015 7.026-8.969s-3.15-8.969-7.026-8.969c-3.88 0-7.025 4.016-7.025 8.969 0 4.954 3.145 8.969 7.025 8.969Z",
    fill: "#fdfdfe",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M999.764 396.704c2.686 0 4.866-2.78 4.866-6.208s-2.18-6.209-4.866-6.209-4.863 2.78-4.863 6.209 2.178 6.208 4.863 6.208",
    fill: "#000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m1081.84 337.312-3.48-2.432-.84-56.259s-2.96-10.152-6.76-13.958c0 0 1.48-48.011-14.57-93.694 0 0-5.06-9.729-29.55-21.149l-62.61-68.64h-.007c3.372-10.57-14.868-15.121-14.868-15.121s-165.934-19.02-205.837-20.935c-.171-.01-.346-.012-.519-.019l-2.742-.099c-.185-.004-.365-.013-.549-.018-30.348-1.05-240.378-7.238-317.269 19.813-26.916 9.834-94.364 56.683-158.542 108.712 0 0-155.193 16.552-203.763 65.181 19.437.518 232.653 6.014 332.54-.039 0 0 10.976-20.727 78.953-16.919-67.977-3.806-78.953 16.919-78.953 16.919-99.884 6.053-313.103.559-332.54.039-3.225 3.229-5.98 6.598-8.187 10.113 0 0-2.956 35.532-.844 68.104 0 0-9.29 16.707-.634 21.785 0 0-10.397 33.523-7.072 39.709 0 0 2.692 3.173 5.7 3.806l-3.642 5.71s.792 13.483 3.642 20.78c0 0-3.008 5.711-3.485 8.883 0 0 8.233 7.827 17.523 9.729v8.036s.843 5.499 6.966 6.134 24.488.845 24.488.845 5.912-1.481 5.912-5.499-.212-7.19-.212-7.19 134 10.257 228.578 7.296c0 0-.475 9.677 2.532 11.897 3.008 2.219 24.752 1.323 24.752 1.323s6.543-.636 6.543-4.972l-.105-8.723s8.075-.318 9.184-6.61c0 0-11.188-83.754 37.366-127.323 0 0 67.977-64.719 121.599 27.071 0 0 21.533 40.397 16.256 109.345l367.537-14.382v-53.509s.843-79.525 73.042-96.02c0 0 73.257-16.708 84.867 100.461 0 0 12.14-6.767 9.6-38.174zm-94.469-62.285s-16.618-89.597-17.673-97.422-23.836-50.607-23.836-50.607",
    fill: "#f2f2f2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.934 238.694c48.57-48.629 203.763-65.181 203.763-65.181 64.178-52.029 131.626-98.878 158.542-108.712C499.13 37.75 709.16 43.938 739.508 44.988c.184.005.364.014.549.018 1.345.048 2.265.081 2.742.1.173.006.348.008.519.017C783.221 47.04 949.155 66.06 949.155 66.06s18.24 4.552 14.868 15.12h.007l62.61 68.641c24.49 11.42 29.55 21.149 29.55 21.149 16.05 45.683 14.57 93.694 14.57 93.694 3.8 3.806 6.76 13.958 6.76 13.958l.84 56.259 3.48 2.432v.007c2.54 31.407-9.6 38.174-9.6 38.174-11.61-117.169-84.867-100.461-84.867-100.461-72.199 16.495-73.042 96.02-73.042 96.02v53.509l-367.537 14.382c5.277-68.948-16.256-109.345-16.256-109.345-53.622-91.79-121.599-27.071-121.599-27.071-48.554 43.569-37.366 127.323-37.366 127.323-1.109 6.292-9.184 6.61-9.184 6.61l.105 8.723c0 4.336-6.543 4.972-6.543 4.972s-21.744.896-24.752-1.323c-3.007-2.22-2.532-11.897-2.532-11.897-94.578 2.961-228.578-7.296-228.578-7.296s.212 3.172.212 7.19-5.912 5.499-5.912 5.499-18.365-.21-24.488-.845c-6.123-.636-6.966-6.134-6.966-6.134v-8.036c-9.29-1.902-17.523-9.729-17.523-9.729.477-3.172 3.485-8.883 3.485-8.883-2.85-7.297-3.642-20.78-3.642-20.78l3.642-5.71c-3.008-.633-5.7-3.806-5.7-3.806-3.325-6.186 7.072-39.709 7.072-39.709-8.656-5.078.634-21.785.634-21.785-2.112-32.572.844-68.104.844-68.104 2.206-3.515 4.962-6.884 8.187-10.113Zm0 0c19.437.518 232.653 6.014 332.54-.039m-332.54.039c19.437.52 232.656 6.014 332.54-.039m0 0s10.976-20.727 78.953-16.919m-78.953 16.919s10.976-20.725 78.953-16.919m0 0 64.811-5.499m0 0-3.485-15.017s-2.85-11.263 4.751-17.343m-1.266 32.36s12.034 48.221 21.744 171.315m218.494-9.949s3.799-16.075 3.799-29.188-2.744-32.36-2.744-32.36c2.955-79.948 0-110.614-1.478-118.864-1.478-8.248-12.878-25.17-12.878-25.17m224.196 103.006s-16.618-89.597-17.673-97.422-23.836-50.607-23.836-50.607",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M963.896 81.197c-3.374 10.591-17.724 8.473-17.724 8.473l-22.291-1.69-4.634-8.248-161.165-15.234s-65.343-4.98-110.105 15.121-110.712 97.352-110.712 97.352v.158h-33.47l72.833-74.254s36.102-32.36 56.369-39.954c20.266-7.617 70.291-19.674 110.195-17.78 39.903 1.915 205.836 20.934 205.836 20.934s18.242 4.552 14.868 15.121Z",
    fill: "#464649",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m919.264 79.727-50.457-4.766L758.084 64.5s-65.339-4.971-110.092 15.123c-44.755 20.092-110.725 97.343-110.725 97.343v7.403l305.367-16.762 103.231-40.608z",
    fill: "#ccc"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m868.807 74.96 50.457 4.767 26.601 47.272-103.231 40.608-305.367 16.762v-7.403s65.97-77.25 110.725-97.343C692.745 59.528 758.084 64.5 758.084 64.5zm0 0 24.174 72.341",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m763.572 171.497-27.36 1.848c-2.272-94.963-5.887-107.56-6.724-109.227 10.174-.384 18.013-.077 21.338.148.618 3.673 10.493 63.31 12.744 107.231zM584.235 181.8l-46.922 2.569v-7.414s15.858-18.569 37.294-39.865zM738.666 44.978C699.55 44.1 652.359 55.57 632.812 62.916c-2.946 1.104-6.253 2.75-9.717 4.733-50.295-4.395-159.793-4.417-204.284-1.6a59 59 0 0 1 3.126-1.24c76.433-26.884 284.519-20.935 316.729-19.83Z",
    fill: "#464649",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M418.994 66.022c-28.701 12.033-93.594 57.352-155.429 107.492l240.229 3.606 72.834-74.253s26.175-23.579 46.471-35.223c-50.227-4.394-159.5-4.417-204.105-1.622Z",
    fill: "#ccc",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M963.885 81.152c-1.776 5.567-6.545 7.617-10.706 8.316l50.791 59.538 22.54.788z",
    fill: "#464649",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m1053.63 171.214-8.98.865a3.09 3.09 0 0 0-2.66 3.989c2.94 9.541 10.79 35.387 13.18 46.609a3.086 3.086 0 0 0 3.02 2.432h6.59c1.87 0 3.32-1.639 3.08-3.491-1.98-14.661-5.34-31.59-10.99-48.313a3.106 3.106 0 0 0-3.24-2.091Z",
    fill: "#de7a4f",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M257.094 174.271s-1.109-24.904 9.184-28.394c0 0 8.213-3.491 32.438-.158l-35.15 27.81z",
    fill: "#464649",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M626.67 431.079s9.794 27.788 44.755 31.144c17.628 1.692 73.517 7.56 90.354-38.493z",
    fill: "#171717",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M371.41 429.864s-2.317-16.776-.439-39.232c0 0-231.571.318-307.781-3.912-4.238-.234-14.46-4.493-14.46-4.493h-.01l-3.621 5.699s.787 13.498 3.621 20.8c0 0-2.992 5.701-3.464 8.879 0 0 8.233 7.819 17.522 9.712v8.045s.833 5.499 6.95 6.13c6.119.631 24.496.856 24.496.856s5.916-1.487 5.916-5.498c0-4.034-.225-7.189-.225-7.189s134.015 10.253 228.577 7.301c0 0-.472 9.668 2.542 11.876 3.014 2.231 24.743 1.33 24.743 1.33s6.545-.631 6.545-4.958l-.09-8.744s8.075-.315 9.178-6.602m-47.257 6.979s22.588-.212 40.322-.845c-17.734.635-40.322.845-40.322.845",
    fill: "#4a4a4b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m62.8 427.326 37.155 2.326m271.455.212s-2.317-16.776-.439-39.232c0 0-231.571.318-307.781-3.912-4.238-.234-14.46-4.493-14.46-4.493h-.01l-3.621 5.699s.787 13.498 3.621 20.8c0 0-2.992 5.701-3.464 8.879 0 0 8.233 7.819 17.522 9.712v8.045s.833 5.499 6.95 6.13c6.119.631 24.496.856 24.496.856s5.916-1.487 5.916-5.498c0-4.034-.225-7.189-.225-7.189s134.015 10.253 228.577 7.301c0 0-.472 9.668 2.542 11.876 3.014 2.231 24.743 1.33 24.743 1.33s6.545-.631 6.545-4.958l-.09-8.744s8.075-.315 9.178-6.602Zm-47.257 6.979s22.588-.212 40.322-.845c-17.734.635-40.322.845-40.322.845Z",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m72.99 263.417-20.176-16.405a31 31 0 0 0-1.214 1.803s-.878 10.523-1.328 25.374l23.349 1.916z",
    fill: "#3d3d3e",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M318.288 241.096c27.734-.428 53.331-1.172 74.07-2.434zm-6.967 13.032-77.782 10.319a.37.37 0 0 0-.294.509l5.389 13.03a.37.37 0 0 0 .337.23l57.817.827c.099 0 .192.04.259.113l10.109 10.368a.37.37 0 0 0 .267.113l46.098-.223c.122 0 .227-.05.295-.149 1.81-2.626 27.174-39.324 37.836-49.918a.361.361 0 0 0-.277-.622c-20.453 1.224-43.72 1.952-70.933 2.373a.37.37 0 0 0-.303.162l-8.559 12.708a.37.37 0 0 1-.259.16",
    fill: "#3d3d3e"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M318.288 241.096c27.734-.428 53.331-1.172 74.07-2.434m-81.037 15.466-77.782 10.319a.37.37 0 0 0-.294.509l5.389 13.03a.37.37 0 0 0 .337.23l57.817.827c.099 0 .192.04.259.113l10.109 10.368a.37.37 0 0 0 .267.113l46.098-.223c.122 0 .227-.05.295-.149 1.81-2.626 27.174-39.324 37.836-49.918a.361.361 0 0 0-.277-.622c-20.453 1.224-43.72 1.952-70.933 2.373a.37.37 0 0 0-.303.162l-8.559 12.708a.37.37 0 0 1-.259.16Z",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m366.634 243.743 11.46-.403a.192.192 0 0 1 .135.334l-22.113 19.9a.2.2 0 0 0-.061.113l-3.898 22.089a.19.19 0 0 1-.187.162l-17.79.156a.19.19 0 0 1-.193-.194l.096-9.909a.193.193 0 0 0-.189-.194l-91.734-1.437a.19.19 0 0 1-.173-.118l-2.776-6.539c-.052-.122.022-.255.153-.266 4.195-.318 58.681-4.435 98.683-7.416a.16.16 0 0 0 .078-.025l28.421-16.232a.2.2 0 0 1 .088-.025z",
    fill: "#fdfdfd",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m874.933 422.196 2.85 13.483 25.966 1.269-2.535-17.925z",
    fill: "#1b1a19",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m569.513 421.718 206.984-7.81c5.277-2.605 4.384-17.56 4.229-23.914-.151-6.175-3.957-11.768-4.341-12.318l-218.516 10.039c.173 1.539 1.846 16.566 2.145 25.438.318 9.359 9.499 8.565 9.499 8.565Z",
    fill: "#4a4a4b",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M776.386 377.682c.384.552 4.192 6.143 4.341 12.318.155 6.355 1.048 21.309-4.229 23.914l-206.984 7.811s-9.184.793-9.499-8.566c-.299-8.872-1.858-23.918-2.031-25.46l-12.13.573c1.664 14.58 2.294 31.661.809 50.974l367.542-14.4v-53.498l-137.817 6.332z",
    fill: "#4a4a4b"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M776.498 413.914c5.277-2.605 4.384-17.559 4.229-23.914-.149-6.175-3.957-11.766-4.341-12.318l.002-.002 137.817-6.332v53.498l-367.542 14.4c1.485-19.313.855-36.394-.809-50.974l12.13-.573c.173 1.542 1.732 16.588 2.031 25.46.315 9.359 9.499 8.566 9.499 8.566zm0 0 137.702-5.196m-137.702 5.196c-.124.061-.232.149-.362.196",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m1081.71 337.326-3.49-2.433-13.49 1.329c3.3 11.042 5.87 24.023 7.37 39.279 0 0 12.15-6.761 9.61-38.175Z",
    fill: "#4a4a4b",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M905.217 287.217s-28.688 31.709-42.35 33.715c-13.663 2.005-244.989 20.067-264.115 12.441s-42.805-22.877-42.805-22.877 14.724 5.171 38.858 6.643c24.135 1.472 256.678-16.189 271.856-17.794 15.179-1.604 38.556-12.128 38.556-12.128",
    fill: "#e6e6e6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M562.953 360.639s17.277 3.612 31.907 3.211c20.006-2.698 264.43-17.296 276.79-18.9 12.36-1.605 38.625-5.983 38.625-5.983-16.377-10.971-25.647-14.446-25.647-14.446s-269.144 14.984-284.595 15.52c0 0-16.069 2.736-37.08 20.598m-25.759-145.428-2.749-11.396s-3.747-12.214 2.834-18.11l204.526-11.263 101.091-5.566 110.989-10.47 71.845-7.429s16.79 6.702 28.15 18.943l-516.688 45.289z",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m756.761 219.729-38.57 2.048a1.8 1.8 0 0 1-1.822-1.304l-2.31-8.16a1.798 1.798 0 0 1 1.656-2.288l40.447-1.586a1.8 1.8 0 0 1 1.863 1.697l.432 7.696a1.8 1.8 0 0 1-1.696 1.897Zm148.492-16.479 2.812 7.781c.256.71.949 1.17 1.7 1.127l37.317-2.051a1.71 1.71 0 0 0 1.601-1.933l-1.131-8.618a1.71 1.71 0 0 0-1.822-1.485l-38.994 2.887a1.714 1.714 0 0 0-1.483 2.292Z",
    fill: "#f2f2f2",
    stroke: "#000",
    strokeWidth: 0.688,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M576.071 380.84s13.883-13.999 26.468-15.267c12.585-1.269 234.104-15.863 234.104-15.863s22.637-3.279 45.362 9.834l31.509-1.322-.918 3.648s-27.532 2.38-47.067-.318c-19.536-2.697-41.91-.369-41.91-.369l-219.072 13.746s-14.029.582-27.138 8.672l-28.744 2.168-.126-3.088 27.53-1.843z",
    fill: "#ddd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M776.309 377.046s3.799-16.074 3.799-29.187-2.744-32.361-2.744-32.361c2.956-79.948 0-110.614-1.478-118.864-1.478-8.248-12.877-25.169-12.877-25.169",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M534.838 179.238s-177.33 15.651-235.172 41.454z",
    fill: "#e6e6e6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M52.035 317.188s111.268 13.325 284.798 4.123c0 0-.318 4.839-1.427 8.487-45.875 5.472-221.939 6.265-287.012-3.847 0 0 1.187-4.124 3.641-8.763",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M245.155 390.347c-67.818-.405-143.508-1.307-181.95-3.245-2.63-.158-10.728-3.403-10.728-3.403l18.287-42.771c40.848 3.628 101.242 4.281 152.977 3.921l23.618 45.431z",
    fill: "#4a4a4b",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M64.702 354.775s59.742 7.191 165.403 3.676z",
    fill: "#4a4a4b"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M64.702 354.775s59.742 7.191 165.403 3.676",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m1076.99 333.76-11.32 1.19c-2.81-9.359-7.33-19.669-11.84-27.243 4.05-23.137.62-83.693.62-83.693.67 1.528 2.29 2.26 3.76 2.26l4.01.02c.87-.027 3.79.298 4.93-.739 3.35 24.545 2.24 39.576 2.24 39.576 4.01 3.888 6.77 13.589 6.77 13.589z",
    fill: "#ddd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m353.522 289.414-19.315.092-.031 42.831c-94.81 4.903-267.055.317-287.209-5.553-.99 4.552-.855 9.42 3.172 11.786 72.518 10.659 286.025 4.868 293.29 4.079 6.096-.66 9.963-6.466 9.963-10.639z",
    fill: "#171717",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M52.036 317.182s109.711 13.009 280.957 4.362l.036-30.866-26.265.147-10.345-10.601-58.503-.872-5.331-12.823-3.536.158c-89.361 2.423-154.74-1.375-154.74-1.375l.634 12.163-23.458-2.01c-.475 31.089.553 41.719.553 41.719z",
    fill: "#ddd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M103.452 315.523c10.826-7.608 41.055-27.62 77.393-41.129 1.059-.395 1.846 1.041.94 1.724-12.075 9.11-44.573 32.004-77.506 41.183-1.061.295-1.732-1.141-.827-1.778Z",
    fill: "#f2f2f2",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M141.606 317.814c9.118 0 16.51-9.908 16.51-22.13s-7.392-22.129-16.51-22.129-16.51 9.907-16.51 22.129 7.392 22.13 16.51 22.13Z",
    fill: "#f4f4f3",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M141.603 312.451c6.561 0 11.879-7.37 11.879-16.46s-5.318-16.46-11.879-16.46c-6.56 0-11.878 7.369-11.878 16.46 0 9.09 5.318 16.46 11.878 16.46Z",
    fill: "#1a1a1a",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M987.426 275.255s-16.618-89.597-17.673-97.421c-1.055-7.827-23.836-50.607-23.836-50.607",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M607.855 167.146s-26.362 23.563-22.95 29.072c3.415 5.51 14.414 9.12 25.605 2.851 11.19-6.271 27.5-32.683 27.5-32.683l-24.277-7.031-5.88 7.791z",
    fill: "#1a1a1a",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M586.235 157.262s6.827-32.872 34.518-25.081c27.692 7.79 44.76 14.44 44.76 27.551s-6.069 20.521-15.932 20.901c-9.863.381-51.019 3.23-59.364-5.89 0 0-6.638-5.891-3.984-17.481z",
    fill: "#4d4d4d",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M663.639 166.738c-1.956 8.232-6.588 12.527-14.053 12.805-9.864.367-50.57 3.215-58.917-5.896 0 0-3.93-3.704-3.835-12.065 3.718.667 37.195 6.774 76.803 5.156z",
    fill: "#333"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M536.19 215.85s12.034 48.22 21.745 171.314",
    stroke: "#000",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M988.119 192.825s-.164-5.406 8.012-5.732c8.179-.327 29.589-4.095 32.369 5.732s8.43 28.523-.9 30.957c-7.81 2.039-31.289 5.118-34.982-6.88-3.615-11.734-4.499-24.077-4.499-24.077Z",
    stroke: "#000",
    strokeWidth: 0.688,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimo);
export default __webpack_public_path__ + "static/media/primo.d2524a42eb7cdfba145b4c22610e42ca.svg";
export { ForwardRef as ReactComponent };